import React,{Component} from 'react';
import './AdminTableDetails.css';
import searchicon from '../../../../image/searchicon.svg'
import {Link} from 'react-router-dom';
class AdminTableDetails extends Component{
    render(){
        return(
                 <div className="tableDetails border shadow mx-auto">
                                    <div className="thead-light fontsize12 text-muted"> 
                                        <div className="form-group has-search   ">
                                            <input type="text" className="form-control badge-pill" placeholder="Search" value={this.props.state.search} name="search" onChange={this.props.handleChange}/>
                                            <img className="ml-2 mt--9 searchiconorders" src={searchicon} alt="Search" />

                                        </div>
                                        <div className="headertable p-3 border">
                                            <p className="m-0">ORDER BY DATE</p>
                                        </div>
                                    </div>
                                    <div className="fontsize12">
                                    {this.props.itemdatatabel}

                                    </div>
                                </div>
            )
    }
}
export default AdminTableDetails;